<template>
  <div class="header">
    <div class="navbar navbar-fixed-top">
      <div class="head_tab">
        <div class="head_tab_top">
          <router-link to="/">
            <img
              src="../assets/images/heardlog.png"
              @click="dianji"
              alt="百才汇"
            />
          </router-link>
          <div class="dengGe" v-if="isShou">
            <p class="dengl" @click="changeResgin('注册')">注册</p>
            <p class="dengl">/</p>
            <p class="dengl" @click="changeResgin('登录')">登录</p>
          </div>
          <div class="user" v-if="userShou">
            <img :src="imgSrc" class="touxiang" alt />
            <p class="shouji">{{ phonenumber }}</p>
            <a href="javascript:;" @click="logout">退出</a>
          </div>
          <span
            class="dow"
            role="button"
            data-toggle="collapse"
            href="#collapseExample"
            aria-expanded="false"
            aria-controls="collapseExample"
          >
            <van-icon name="wap-nav" size="30px" />
          </span>
        </div>
        <div class="head-tab-main collapse" id="collapseExample">
          <van-cell title="上海落户" @click="Toshouye()"
            ><van-icon name="arrow"
          /></van-cell>
          <van-cell title="留学生落户" @click="Toliuxueluohu()"
            ><van-icon name="arrow"
          /></van-cell>
          <van-cell title="居转户" @click="Tojuzhuanhu()"
            ><van-icon name="arrow"
          /></van-cell>
          <van-cell title="人才引进" @click="Torencaiyinjin()"
            ><van-icon name="arrow"
          /></van-cell>
          <van-cell title="海归名企实习" @click="Tohaiguiqiyeshixi()"
            ><van-icon name="arrow"
          /></van-cell>
          <div class="yaowendongtaiNavbox" @click="Yaowendongtai()">
            <div class="yaowendongNavtai_titlebox">
              <p>要闻动态</p>
              <van-icon name="arrow" v-if="yaowendongNavtaiBlick == true" />
              <van-icon
                name="arrow-down"
                v-if="yaowendongNavtaiBlick == false"
              />
            </div>
            <div class="yaowendongNavtai_con">
              <p @click="Toluohuzhence()">落户政策</p>
              <p @click="Tochangjianwenda()">常见问答</p>
            </div>
          </div>
          <van-cell title="联系我们" @click="Tolianxiwomen()"
            ><van-icon name="arrow"
          /></van-cell>
        </div>
      </div>
    </div>
    <!-- 登录弹框 -->
    <div class="loginRegistration" v-if="dialogVisible">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="loginRegistration_form"
      >
        <div class="prompt">
          <p class="p1">{{ title }}账号</p>
        </div>
        <div class="enter">
          <div class="tip">
            <p>新用户登陆后将自动创建账号</p>
          </div>
          <el-form-item prop="tel" class="getTel">
            <el-input
              v-model="ruleForm.tel"
              placeholder="+86 请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code" class="getCode">
            <el-input
              v-model="ruleForm.code"
              placeholder="请填写手机验证码"
            ></el-input>
            <el-button
              tabindex="-1"
              @click="getCode"
              :disabled="disabled"
              class="getCode_btn"
              >{{ codeInfo }}</el-button
            >
          </el-form-item>
          <el-form-item class="loginBtnbox">
            <div class="terms">
              <el-checkbox v-model="ruleForm.checked"></el-checkbox>
              <p class="xy">
                我已阅读并同意
                <a href="javascript:;" tabindex="-1" @click="protocol"
                  >《留归用户协议》</a
                >
                <a href="javascript:;" tabindex="-1" @click="protocolEr"
                  >《隐私政策》</a
                >
              </p>
            </div>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              class="loginBtn"
              v-loading.fullscreen.lock="loading"
              >登录</el-button
            >
          </el-form-item>
        </div>
      </el-form>
      <Foot></Foot>
    </div>
    <UserAgreement
      :isbool="isbool"
      @close-dialogStatus="closeDialog"
      @isShow="isShow"
    ></UserAgreement>
    <PrivacyPolicy
      :isbool="isboolEr"
      @close-dialogStatus="closeDialogEr"
      @isShowEr="isShowEr"
    ></PrivacyPolicy>
    <!-- 需要存储cookie的页面 -->
    <iframe
      v-for="(item, index) in pagesArrs"
      :key="index"
      @load="PagesLoading"
      :src="item"
      frameborder="0"
      width="0"
      height="0"
    ></iframe>
  </div>
</template>
<script>
import Bus from "./bus.js";
import UserAgreement from "./UserAgreement.vue";
import PrivacyPolicy from "./PrivacyPolicy.vue";
import Foot from "./Foot.vue";
import { getCookie, setCookie, delCookie } from "../util/util.js";
import Vue from "vue";
import { Notify } from "vant";
export default {
  components: { UserAgreement, PrivacyPolicy, Foot },
  data() {
    return {
      isbool: false,
      isboolEr: false,
      activeName: 0,
      menu: [],
      isShou: true, // 登录注册
      userShou: false, // 用户名
      dialogVisible: false, // 登录弹框
      pagesArrs: [], // 需要存储cookie页面的数组
      title: "", // 登录注册改变
      ruleForm: {
        tel: "",
        code: "",
        checked: false,
      },
      rules: {
        tel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      disabled: false,
      codeInfo: "获取验证码",
      //登录按钮加载中
      loading: false,
      pageNum: 0,
      phoneCookie: this.getCookie("tel"),
      imgSrc: require("../assets/images/denglu_qiehuan.png"),
      phonenumber: "",
      yaowendongNavtaiBlick: true,
      flag: true,
    };
  },
  methods: {
    isShow() {
      this.isbool = false;
    },
    isShowEr() {
      this.isboolEr = false;
    },
    // iframe页面改变
    PagesLoading() {
      this.pageNum++;
    },
    // 登陆注册改变
    changeResgin(title) {
      this.dialogVisible = true;
      Bus.$emit("isLoginFun", false);
      this.title = title;
    },
    // 点击退出按钮
    logout() {
      sessionStorage.clear();
      localStorage.clear();
      delCookie("Phone");
      delCookie("Data");
      this.isShou = true;
      this.userShou = false;
    },
    // 设置cookie
    setCookie,
    // 获取cookie
    getCookie,
    // 登录
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.checked) {
            Notify({
              type: "warning",
              message: "请阅读并同意《留归用户协议》《隐私政策》",
            });
            return false;
          }
		  // 弹框关闭
		  this.dialogVisible = false;
		  Bus.$emit("isLoginFun", true);
		  // 存储手机
		  sessionStorage.setItem(
		    "Phone",
		    this.ruleForm.tel
		  );
		  localStorage.setItem("Phone", this.ruleForm.tel);
		  setCookie("Phone", this.ruleForm.tel, 28800),
		  // 右上角手机号
		  this.phonenumber = this.ruleForm.tel;
		  this.isShou = false;
		  this.userShou = true;
		  return
          this.$axios
            .post("/api/Oauth2/AccessToken", {
              UserCode: this.ruleForm.tel,
              Code: this.ruleForm.code,
            })
            .then((res) => {
              if (res.data.Code == 200) {
                this.$axios
                  .post("/trip/TokenPass/CheckLoginCode", {
                    Phone: this.ruleForm.tel,
                  })
                  .then((res) => {
                    if (res.data.Code == 200) {
                      this.loading = true;
                      // 拿到产品详细信息
                      const productStep =
                        res.data.Data.productStep == null
                          ? []
                          : res.data.Data.productStep;
                      // 拿到ssotoken
                      const _token = res.data.Data.SsoToken;
                      // 拿到Data
                      var _Data = res.data.Data;
                      // 步骤数组
                      const StepArr = [];
                      productStep.forEach((el) => {
                        StepArr.push(el.StepNum);
                      });
                      // 判断步骤数组是否含有5
                      if (StepArr.includes(5)) {
                        this.$axios
                          .post("/apivip/Oauth2/AccessToken", {
                            Ticket: _token,
                          })
                          .then((res) => {
                            let d = res.data.Data;
                            if (res.data.Code == 200) {
                              // 弹框关闭
                              this.dialogVisible = false;
                              Bus.$emit("isLoginFun", true);
                              // 存储手机
                              sessionStorage.setItem(
                                "Phone",
                                this.ruleForm.tel
                              );
                              localStorage.setItem("Phone", this.ruleForm.tel);
                              setCookie("Phone", this.ruleForm.tel, 28800),
                                // 存储Data
                                sessionStorage.setItem(
                                  "Data",
                                  JSON.stringify(_Data)
                                );
                              setCookie("Data", JSON.stringify(_Data), 28800),
                                localStorage.setItem(
                                  "Data",
                                  JSON.stringify(_Data)
                                );
                              // 右上角手机号
                              this.phonenumber = this.ruleForm.tel;
                              this.isShou = false;
                              this.userShou = true;
                            } else {
                              Notify({
                                type: "danger",
                                message: res.data.Message,
                              });
                            }
                          });
                      } else {
                        // 弹框关闭
                        this.dialogVisible = false;
                        Bus.$emit("isLoginFun", true);
                        this.loading = false;
                        // 存储手机
                        sessionStorage.setItem("Phone", this.ruleForm.tel);
                        setCookie("Phone", this.ruleForm.tel, 28800),
                          // 存储Data
                          sessionStorage.setItem("Data", JSON.stringify(_Data));
                        setCookie("Data", JSON.stringify(_Data), 28800),
                          // 右上角手机号
                          (this.phonenumber = this.ruleForm.tel);
                        this.$router.push("/zhengcezhongxin");
                        this.isShou = false;
                        this.userShou = true;
                      }
                      //   }
                      // }, 350);
                    } else {
                      Notify({ type: "danger", message: res.data.Message });
                      this.ruleForm.tel = "";
                      this.ruleForm.code = "";
                    }
                  });
              } else {
                Notify({
                  type: "danger",
                  message: res.data.Message,
                });
                this.dialogVisible = false;
              }
            });
        } else {
          return false;
        }
      });
    },
    // 登录短信验证
    getCode() {
      // 正则校验手机号是否合法
      if (this.ruleForm.tel) {
        // 手机号正确执行
        this.disabled = true;
        this.$axios
          .post("/smsapi/Message/SendSmsCode", {
            Phone: this.ruleForm.tel,
          })
          .then((res) => {
            if (res.data.Code == 200) {
              Notify({ type: "success", message: "验证码已发送请注意查收!" });
              // 倒计时开始
              let num = 60;
              let timeStep = setInterval(() => {
                num--;
                if (num > 0) {
                  this.codeInfo = "请在" + num + "s后重试";
                } else {
                  clearInterval(timeStep);
                  this.codeInfo = "获取验证码";
                  this.disabled = false;
                }
              }, 1000);
            } else {
              Notify({ type: "danger", message: res.data.Message });
              this.disable = false;
            }
          })
          .catch(() => {
            this.disable = false;
          });
      } else {
        Notify({ type: "warning", message: "请输入正确手机号" });
      }
    },
    // 注册短信验证
    getCodeZhuCe() {
      // 正则校验手机号是否合法
      if (this.ruleForm.tel) {
        // 手机号正确执行
        this.disabled = true;
        this.$axios
          .post("/smsapi/Message/SendSmsCode", {
            Phone: this.ruleForm.tel,
          })
          .then((res) => {
            if (res.data.Code == 200) {
              Notify({ type: "success", message: "验证码已发送请注意查收!" });
              // 倒计时开始
              let num = 60;
              let timeStep = setInterval(() => {
                num--;
                if (num > 0) {
                  this.codeInfo = "请在" + num + "s后重试";
                } else {
                  clearInterval(timeStep);
                  this.codeInfo = "获取验证码";
                  this.disabled = false;
                }
              }, 1000);
            } else {
              Notify({ type: "danger", message: res.data.Message });
              this.disable = false;
            }
          })
          .catch(() => {
            this.disable = false;
          });
      } else {
        Notify({ type: "warning", message: "请输入正确手机号" });
      }
    },
    getList() {
      this.$axios
        .post("/trip/TokenPass/GetMenuTree", {
          Source: "126",
          IsView: 1,
        })
        .then((res) => {
          this.menu = JSON.parse(res.data.Data);
        });
    },
    dianji() {
      this.dialogVisible = false;
      Bus.$emit("isLoginFun", true);
      this.$router.push("/");
    },

    // 用户协议弹框
    protocol() {
      this.isbool = true;
    }, // 用户隐私协议弹框
    protocolEr() {
      this.isboolEr = true;
    },
    closeDialog() {
      this.isbool = false;
    },
    closeDialogEr() {
      this.isboolEr = false;
    },
    //点击导航菜单跳转相应页面
    //首页
    Toshouye() {
      this.$router.push("/");
      $(".collapse").toggleClass("in");
      const YaowenDongtaicon = document.getElementsByClassName(
        "yaowendongNavtai_con"
      );
      for (let i = 0; i < YaowenDongtaicon.length; i++) {
        YaowenDongtaicon[i].style.display = "none";
      }
    },
    //留学生落户
    Toliuxueluohu() {
      this.$router.push("/liuxueshengluohu.html");
      $(".collapse").toggleClass("in");
      const YaowenDongtaicon = document.getElementsByClassName(
        "yaowendongNavtai_con"
      );
      for (let i = 0; i < YaowenDongtaicon.length; i++) {
        YaowenDongtaicon[i].style.display = "none";
      }
    },
    //居转户
    Tojuzhuanhu() {
      this.$router.push("/juzhuanhu.html");
      $(".collapse").toggleClass("in");
      const YaowenDongtaicon = document.getElementsByClassName(
        "yaowendongNavtai_con"
      );
      for (let i = 0; i < YaowenDongtaicon.length; i++) {
        YaowenDongtaicon[i].style.display = "none";
      }
    },
    //人才引进
    Torencaiyinjin() {
      this.$router.push("/talenti.html");
      $(".collapse").toggleClass("in");
      const YaowenDongtaicon = document.getElementsByClassName(
        "yaowendongNavtai_con"
      );
      for (let i = 0; i < YaowenDongtaicon.length; i++) {
        YaowenDongtaicon[i].style.display = "none";
      }
    },
    //海归名企实习
    Tohaiguiqiyeshixi() {
      this.$router.push("/faovrt.html");
      $(".collapse").toggleClass("in");
      const YaowenDongtaicon = document.getElementsByClassName(
        "yaowendongNavtai_con"
      );
      for (let i = 0; i < YaowenDongtaicon.length; i++) {
        YaowenDongtaicon[i].style.display = "none";
      }
    },
    //要闻动态
    Yaowendongtai() {
      if (this.flag) {
        this.yaowendongNavtaiBlick = false;
        this.flag = false;
        const YaowenDongtaicon = document.getElementsByClassName(
          "yaowendongNavtai_con"
        );
        for (let i = 0; i < YaowenDongtaicon.length; i++) {
          YaowenDongtaicon[i].style.display = "block";
        }
      } else {
        this.flag = true;
        this.yaowendongNavtaiBlick = true;
        const YaowenDongtaicon = document.getElementsByClassName(
          "yaowendongNavtai_con"
        );
        for (let i = 0; i < YaowenDongtaicon.length; i++) {
          YaowenDongtaicon[i].style.display = "none";
        }
      }
    },
    //落户政策
    Toluohuzhence() {
      this.$router.push("/luohuzhengce.html");
      $(".collapse").toggleClass("in");
      const YaowenDongtaicon = document.getElementsByClassName(
        "yaowendongNavtai_con"
      );
      for (let i = 0; i < YaowenDongtaicon.length; i++) {
        YaowenDongtaicon[i].style.display = "none";
      }
    },
    //常见问答
    Tochangjianwenda() {
      this.$router.push("/changjianwenda.html");
      $(".collapse").toggleClass("in");
      const YaowenDongtaicon = document.getElementsByClassName(
        "yaowendongNavtai_con"
      );
      for (let i = 0; i < YaowenDongtaicon.length; i++) {
        YaowenDongtaicon[i].style.display = "none";
      }
    },
    //联系我们
    Tolianxiwomen() {
      this.$router.push("/lianxiwomen.html");
      $(".collapse").toggleClass("in");
      const YaowenDongtaicon = document.getElementsByClassName(
        "yaowendongNavtai_con"
      );
      for (let i = 0; i < YaowenDongtaicon.length; i++) {
        YaowenDongtaicon[i].style.display = "none";
      }
    },
  },
  mounted() {
    this.getList();
    if (
      sessionStorage.getItem("Phone") ||
      getCookie("tel") ||
      getCookie("Phone") ||
      localStorage.getItem("Phone")
    ) {
      this.isShou = false;
      this.userShou = true;
      this.phonenumber =
        sessionStorage.getItem("Phone") ||
        getCookie("tel") ||
        getCookie("Phone") ||
        localStorage.getItem("Phone");
    }
  },
};
</script>
<style lang="scss" scope>
.header {
  .navbar {
    margin: 0;
    padding: 0;
  }
  .header_top {
    max-height: 120px;
    min-height: 120px;
    background: #4c4c4c;
    background-color: #4c4c4c;
    color: white;
    padding-top: 25px;
    .left,
    .rigt {
      text-align: center;
      p {
        font-size: 22px;
        font-weight: bold;
        span {
          font-size: 16px;
          font-weight: Regular;
          margin-left: 10px;
        }
        a {
          font-size: 22px;
          font-weight: bold;
          color: #fff;
          text-decoration: none;
          margin-left: 10px;
        }
        .iconfont {
          font-size: 22px;
          font-weight: bold;
          margin-right: 13px;
        }
      }
    }
    .rigt {
      margin-top: 6px;
    }
  }
  .head_tab {
    width: 100%;
    height: auto;
    background: pink;
    position: relative;
    .head_tab_top {
      width: 100%;
      height: 80px;
      padding: 0px 30px;
      box-sizing: border-box;
      line-height: 80px;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 999;
      img {
        width: 279px;
        height: 32px;
      }
      .dengGe {
        margin-left: auto;
        margin-right: 30px;
        display: flex;
        .dengl {
          letter-spacing: 2px;
          font-size: 22px;
          font-weight: 400;
          line-height: 90px;
          color: #aa8756;
        }
      }
      .user {
        margin-left: auto;
        margin-right: 30px;
        display: flex;
        align-items: center;
        line-height: 100px;
        .touxiang {
          height: 40px;
          width: 40px;
        }
        .shouji {
          font-size: 12px;
          color: #aa8756;
          letter-spacing: 1px;
          margin-left: 5px;
        }
        a {
          font-size: 12px;
          margin-left: 5px;
        }
      }
      .dow {
        margin-top: 16px;
        cursor: pointer;
        i {
          color: #aa8756;
        }
      }
    }

    .head-tab-main {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      margin-top: 80px;
    }
    #collapseExample {
      background: #fff;
      .van-cell {
        background: #e1b170;
        .van-cell__title {
          span {
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
            line-height: 29px;
            letter-spacing: 1px;
          }
        }
        .van-cell__value {
          i {
            font-size: 24px;
            color: white;
          }
        }
      }
      .van-cell::after {
        left: 0;
        right: 0;
        border-bottom: 1px solid #ebc897;
      }
      .yaowendongtaiNavbox {
        border-bottom: 1px solid #ebc897;
        .yaowendongNavtai_titlebox {
          width: 750px;
          background: #e1b170;
          display: flex;
          padding: 20px 30px;
          p {
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
            letter-spacing: 1px;
          }
          i {
            color: #ffffff;
            margin-top: 5px;
            font-size: 24px;
            margin-left: auto;
          }
        }
        .yaowendongNavtai_con {
          display: none;
          padding: 34px 30px;
          background: #ebc897;
          p {
            font-size: 22px;
            font-weight: 400;
            color: #ffffff;
            letter-spacing: 1px;
            margin-top: 20px;
          }
          p:first-child {
            margin-top: 0;
          }
        }
        .yaowendongNavtai_conblok {
          display: block;
        }
      }
    }
  }
  //登录样式
  .loginRegistration {
    margin-top: 88px;
    background: #f5f5f5;
    padding-top: 30px;
    .loginRegistration_form {
      .prompt {
        width: 50%;
        height: 78px;
        background: #fff;
        color: #666;
        text-align: center;
        line-height: 95px;
        font-size: 32px;
      }
      .enter {
        background: #fff;
        padding-top: 80px;
        padding-bottom: 60px;
        .tip {
          // width: 576px;
          width: 80%;
          margin: 0 auto;
          p {
            font-size: 26px;
            color: #666;
          }
        }
        .getTel,
        .getCode,
        .loginBtnbox {
          // width: 576px;
          width: 80%;
          margin: 0 auto;
          margin-top: 50px;
        }
        .getTel {
          .el-form-item__content {
            width: 100%;
            input {
              width: 100%;
              height: 90px;
              font-size: 26px;
            }
          }
        }
        .getCode {
          .el-form-item__content {
            width: 100%;
            display: flex;
            input {
              width: 95%;
              height: 90px;
              font-size: 26px;
            }
            .getCode_btn {
              width: 190px;
              font-size: 12px;
              padding: 10px;
            }
          }
        }
        .loginBtnbox {
          margin-top: 30px;
          .el-form-item__content {
            .terms {
              display: flex;
              margin-bottom: 15px;
              .el-checkbox {
                margin-right: 11px;
              }
              .xy {
                font-size: 22px;
              }
            }
            .loginBtn {
              background: #aa8756;
              width: 100%;
              border: 0;
            }
          }
        }
      }
    }
  }
}
</style>